/*
 * Public API Surface of inova-core
 */

export * from './generic-constants'


